import React, { useEffect, useState } from "react";
import Styles from "./index.module.scss";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import swapTitle from "./swapTitle";
import Sidenav from "../../components/sidenav/Sidenav";
import Navbar from "../../components/Navbar/Navbar";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import AddBatch from "../cylinder/addBatch/AddBatch.component";
import IdleTimer from "../../helper/idleTimer";

const Layout = ({ cylinderCode }) => {
  const [navTitle, setnavTitle] = useState("Dashboard");
  const path = useLocation();
  const [handleHamburger, sethandleHamburger] = useState(false);

  const [openModal, setopenModal] = useState(false);

  const userDetails = localStorage.getItem("userDetails");

  const [isTimeout, setIsTimeout] = useState(false);

  useEffect(() => {
    const timer = new IdleTimer({
      timeout: 600, //expire after 10mins
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        // do something if expired on load
        setIsTimeout(true);
      },
    });

    return () => {
      timer.cleanUp();
    };
  }, []);

  useEffect(() => {
    if (isTimeout) {
      localStorage.removeItem("newOrder");
      localStorage.removeItem("precheck");
      localStorage.removeItem("cylinderOption");
      localStorage.removeItem("trackOrder");
      localStorage.removeItem("orderType");
      localStorage.removeItem("genotype");
      localStorage.removeItem("userDetails");
    }
  }, [isTimeout]);

  // Set nav title each time there's a path change
  useEffect(() => {
    setnavTitle(path.pathname);
  }, [path, userDetails]);

  return userDetails ? (
    <section className={Styles.adminDashboardCont}>
      <div className={Styles.sidebarContOuter}>
        <Sidenav
          active={Styles.active}
          onClickYes={() => setopenModal(true)}
          cylinderId={cylinderCode}
        />
      </div>

      <div className={Styles.mainContent}>
        <Navbar
          title={swapTitle[navTitle]}
          handleHamburger={handleHamburger}
          sethandleHamburger={sethandleHamburger}
        />
        {/* Component Children */}

        <Outlet />
        {/* DIALOG MODAL */}
        <ConfirmationModal
          open={openModal}
          handleClose={() => setopenModal(false)}
          closemodal={() => setopenModal(false)}
          bgcolor='background.paper'
          width='30%'
          instruction={<AddBatch onClickYes={() => setopenModal(false)} />}
        />
      </div>
    </section>
  ) : (
    <Navigate to='login' replace />
  );
};

export default Layout;
